import Immutable from 'immutable';
import {
  FLAG_GETTING_IN_SYSTEM_NOTIFICATIONS,
  GET_IN_SYSTEM_NOTIFICATIONS,
  CLEAR_IN_SYSTEM_NOTIFICATIONS,
  FLAG_IN_SYSTEM_NOTIFICATION_ACTIVITY,
  CLEAR_IN_SYSTEM_NOTIFICATION,
  GET_IN_SYSTEM_NOTIFICATION,
} from '../../../actions/types/index';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_IN_SYSTEM_NOTIFICATIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_IN_SYSTEM_NOTIFICATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_IN_SYSTEM_NOTIFICATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_IN_SYSTEM_NOTIFICATION_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_IN_SYSTEM_NOTIFICATION:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_IN_SYSTEM_NOTIFICATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
